import React, { useState } from 'react';
import { FinanceSection } from './FinanceSection.js';
import { FixedCostsSection } from './FixedCostsSection.js';
import { InvoiceSettingsSection } from './InvoiceSettingsSection.js';
import { FinanceDashboard } from './FinanceDashboard.js';
import FinanceMovimentiPage from './FinanceMovimentiPage.js';
import { PageHeader } from '../../components/ui/PageHeader.js';
import { TabNav } from '../../components/ui/TabNav.js';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div
      className="animate-in"
      style={{
        background: 'var(--glass-bg-card)',
        border: '1px solid rgba(255,255,255,0.10)',
        borderRadius: 'var(--radius-card)',
        padding: '1.25rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <h3 style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--color-text)' }}>
        {title}
      </h3>
      <div>{children}</div>
    </div>
  );
}

type TabId = 'dashboard' | 'finanza' | 'costi' | 'fatturazione' | 'movimenti';

const TABS: { id: TabId; label: string }[] = [
  { id: 'dashboard',    label: 'Dashboard' },
  { id: 'finanza',      label: 'Tariffe e Fisco' },
  { id: 'costi',        label: 'Costi Fissi' },
  { id: 'fatturazione', label: 'Dati Fatturazione' },
  { id: 'movimenti',    label: 'Movimenti' },
];

export default function FinancePage() {
  const [activeTab, setActiveTab] = useState<TabId>('dashboard');

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <PageHeader title="Finanza" />
      <TabNav tabs={TABS} active={activeTab} onChange={(id) => setActiveTab(id as TabId)} />

      {/* Tab content */}
      {activeTab === 'dashboard' && (
        <FinanceDashboard />
      )}

      {activeTab === 'finanza' && (
        <Section title="Tariffe e Regime Fiscale">
          <FinanceSection />
        </Section>
      )}

      {activeTab === 'costi' && (
        <Section title="Costi Fissi Mensili">
          <FixedCostsSection />
        </Section>
      )}

      {activeTab === 'fatturazione' && (
        <Section title="Dati Fatturazione">
          <InvoiceSettingsSection />
        </Section>
      )}

      {activeTab === 'movimenti' && (
        <FinanceMovimentiPage />
      )}
    </div>
  );
}
